var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"centralizar"},[_c('table',_vm._l((_vm.grid),function(line,i){return _c('tr',{key:i,staticClass:"quadrado"},_vm._l((line),function(cell,j){return _c('td',{key:j,staticClass:"quadrado",class:{ vivo: cell == 1 }})}),0)}),0),_c('a',{staticClass:"link",attrs:{"href":"https://github.com/tabataf"}},[_vm._v("By: Tábata de Faria")])])
}
var staticRenderFns = []

export { render, staticRenderFns }